import { apiWithOptionalCode } from './base/api-with-optional-code'

const sharedCustomerHasSumsData = (params = {}) => {
  return apiWithOptionalCode('/customer-has-sums-data')(params)
}

export default sharedCustomerHasSumsData